import Dexie, { Table } from 'dexie';
import { RequestData, Collection, Environment, Workspace } from '../types';

export interface HistoryItem {
  id: string;
  workspaceId: string;
  request: RequestData;
  response: any;
  timestamp: number;
}

export interface AppSettings {
  id: string;
  theme: 'dark' | 'light';
  activeEnvironmentId: string | null;
  activeWorkspaceId: string | null;
  sidebarTab: string;
  requestPanelTab: string;
}

export interface TabState {
  id: string;
  workspaceId: string;
  activeTabId: string;
  tabs: any[];
}

export class AppDatabase extends Dexie {
  workspaces!: Table<Workspace>;
  requests!: Table<RequestData>;
  collections!: Table<Collection>;
  history!: Table<HistoryItem>;
  environments!: Table<Environment>;
  settings!: Table<AppSettings>;
  tabState!: Table<TabState>;

  constructor() {
    super('ApiStudioDB');
    this.version(3).stores({
      workspaces: 'id, isActive',
      requests: 'id, workspaceId, collectionId',
      collections: 'id, workspaceId',
      history: 'id, workspaceId, timestamp',
      environments: 'id, workspaceId',
      settings: 'id',
      tabState: 'id, workspaceId'
    });
  }
}

export const db = new AppDatabase();
